export const navLinks = [
	{ label: 'Domů', to: '/' },
	{ label: 'Tréninky', to: '/treninky' },
	{ label: 'Trenéři', to: '/treneri' },
	{ label: 'Kontakt', to: '/kontakt' },
];
